import { AxiosError, isAxiosError } from 'axios'

interface Error {
  message: string
}

export type QueryError = AxiosError<Error>

export function isQueryError(error: unknown): error is QueryError {
  // check if error is AxiosError and has response body with message that is a string
  return (
    isAxiosError(error) &&
    typeof error === 'object' &&
    error !== null &&
    'response' in error &&
    typeof (error as any).response === 'object' &&
    (error as any).response !== null &&
    'data' in (error as any).response &&
    typeof (error as any).response.data === 'object' &&
    (error as any).response.data !== null &&
    'message' in (error as any).response.data &&
    typeof (error as any).response.data.message === 'string'
  )
}

export function getErrorMessage(error: unknown): string {
  if (isQueryError(error)) {
    return error.response?.data.message || error.message
  }
  if (error instanceof Error) {
    return error.message
  }
  return 'Wystąpił nieznany błąd.'
}
